function decodeHtmlEntities(text: string): string {
  return text
    .split('&lt;')
    .join('<')
    .split('&gt;')
    .join('>')
    .split('&quot;')
    .join('"')
    .split('&#34;')
    .join('"')
    .split('&#39;')
    .join("'")
    .split('&apos;')
    .join("'")
    .split('&amp;')
    .join('&');
}

/** Как в NewsItem: в БД/ответе разметка часто приходит экранированной (&lt;, &quot; …). */
export function decodeNewsHtmlText(text: string): string {
  return decodeHtmlEntities(text)
    .replace(/<p(?:\s[^>]*)?>(?:\s|&nbsp;|\u00a0|<br\s*\/?>)*<\/p>/gi, '')
    .trim();
}

/** Есть ли в тексте news/анонса HTML-разметка (без DOM — безопасно вызывать при рендере). */
export function isNewsHtmlText(text: string | undefined | null): boolean {
  if (!text) {
    return false;
  }

  const sample =
    text.includes('&lt;') || text.includes('&gt;') || text.includes('&quot;') ? decodeHtmlEntities(text) : text;

  if (sample.includes('data-editor="editor"')) {
    return true;
  }

  return /<\/?[a-z][\s\S]*?>/i.test(sample);
}
